/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
// Returns version number of current release
// Version number placeholder is replaced by the precise release version number at the time of
// release
// Relevant configuration located in semantic-release configuration file
export const getDataManagerUiVersion = (): string => {
    return "3.0.2"; // Version number placeholder
};
